import { Injectable } from '@angular/core';
import { BrowserService } from 'projects/shared/services/browser.service';
import { LocalStorageRefService } from 'projects/shared/services/localStorageRef.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LightModeService {
  lightMood = new BehaviorSubject<boolean>(false);
  storage: Storage | null;

  constructor(private localStorageRef: LocalStorageRefService, private _browserService: BrowserService) {
    this.storage = this.localStorageRef.localStorage;

    const localStorageBr = _browserService.getLocalStorage();

    if (localStorageBr) {

      const mode = this.storage?.getItem('lightMode');

      if (!mode) {
        this.storage?.setItem('lightMode', 'false');
        this.lightMood.next(false);
      } else {
        this.lightMood.next(mode === 'true');
      }

    }
  }
}
